module.exports = __webpack_public_path__ + "img/icon-fund-active.0a71882a.svg";